import React, { type ReactNode } from 'react';
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';

import { Flex, Icon, Text } from 'core/components';

interface Props {
  excluded?: boolean;
  children: ReactNode;
}

const FilterDisplayHeader = ({ excluded = false, children }: Props) => (
  <Flex alignItems="center" fontSize="small">
    <Icon color={excluded ? 'danger' : 'success'} icon={excluded ? FiMinusCircle : FiPlusCircle} mr="4px" />
    <Text color="muted">{children}</Text>
  </Flex>
);

export default FilterDisplayHeader;
